import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("habit_token");
    if (!token) {
      setUser(false);
      setChecked(true);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("habit_token");
        setUser(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const loginSuccess = (data) => {
    localStorage.setItem("habit_token", data.token);
    setUser(data.user);
  };

  const refreshUser = async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      return res.data;
    } catch (e) {}
  };

  useEffect(() => {
    const onFocus = () => {
      if (localStorage.getItem("habit_token")) {
        api.get("/auth/me").then((res) => setUser(res.data)).catch(() => {});
      }
    };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    localStorage.removeItem("habit_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, checked, loginSuccess, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
